import React from 'react';

export const Select = ({
  formName,
  defaultValue,
  values,
  onChange,
  ariaLabelledBy,
}) => {
  return (
    <select
      type="select"
      className="select select-sm"
      name={formName}
      defaultValue={defaultValue}
      onChange={(event) => onChange(event.target.value)}
      aria-labelledby={ariaLabelledBy}
    >
      {values.map(({ value, label }) => (
        <option value={value} key={value}>
          {label}
        </option>
      ))}
    </select>
  );
};
